export const external_link = () => (
  <path
    d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6m4-3h6m0 0v6m0-6L10 14"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
